import React, { useEffect, useState } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { Routes } from "./routes/index";
import "./i18n";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import keycloak from "./keycloak";
import axiosInterceptor from "./utils/axiosInterceptor";
import { useStores } from "./hooks/useStores";

const eventLogger = (event: any, error: any) => {
  console.log(event, error);
};

const tokenLogger = (tokens: any) => {
  if (tokens.token) {
    localStorage.setItem("keycloak-token", tokens.token);
    axiosInterceptor();
  }
};

export const App = () => {
  const [spinner, setSpinner] = useState(false);

  const {
    myTibStore,
    myTimStore,
    notificationStore,
  } = useStores();

  useEffect(() => {
    setSpinner(true)
    setTimeout(() => {
      fetchData();
      setSpinner(false);
    }, 1500);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchData = () => {
    myTibStore.getMyProfile()
      .then(() => {
        myTibStore.getSettings().then(() => notificationStore.getAvisos());
        myTimStore.getCard();
        myTimStore.getWalletOperations();
        myTimStore.getCappingValue();
        myTibStore.getMyProfile();
        myTibStore.getFavLines();
        myTibStore.getFavStops();
        notificationStore.getAlerts();
        notificationStore.getMyNotifications();
      });
  };

  return (
    <React.StrictMode>
      <ReactKeycloakProvider
        authClient={keycloak as any}
        initOptions={{ onLoad: "login-required", checkLoginIframe: false }}
        LoadingComponent={<div></div>}
        isLoadingCheck={(kc) => !kc.authenticated}
        onEvent={eventLogger}
        onTokens={tokenLogger}
      >
        {spinner ? <div className="overlay"><div className="loader"></div></div> : null}
        <Router basename="/extranet">
          <Routes />
        </Router>
      </ReactKeycloakProvider>
    </React.StrictMode>
  );
};
